import request from '@/utils/request'

export function qualityGoods_index(data) {
  return request({
    url: '/merchant/PackingGoods/index/',
    method: 'get',
    params: data
  })
}

export function packingEmployee_index(data) {
  return request({
    url: '/merchant/PackingEmployee/index',
    method: 'get',
    params: data
  })
}

export function packingEmployee_save(data) {
  return request({
    url: '/merchant/PackingEmployee/save',
    method: 'post',
    data: data
  })
}

export function packingEmployee_del(data) {
  return request({
    url: '/merchant/PackingEmployee/del',
    method: 'post',
    data: data
  })
}

export function packingGoods_statistics(data) {
  return request({
    url: '/merchant/PackingGoods/statistics',
    method: 'get',
    params: data
  })
}

export function packingGoods_efficiency(data) {
  return request({
    url: '/merchant/PackingGoods/efficiency',
    method: 'get',
    params: data
  })
}

export function packingGoods_goodsIndex(data) {
  return request({
    url: '/merchant/PackingGoods/goodsIndex',
    method: 'get',
    params: data
  })
}

export function packingGoods_savePackingInfo(data) {
  return request({
    url: '/merchant/PackingGoods/savePackingInfo',
    method: 'post',
    data: data
  })
}

export function packingGoods_save(data) {
  return request({
    url: '/merchant/PackingGoods/save',
    method: 'post',
    data: data
  })
}

export function packingGoods_del(data) {
  return request({
    url: '/merchant/PackingGoods/del',
    method: 'post',
    data: data
  })
}

export function packingGoods_editPackingInfo(data) {
  return request({
    url: '/merchant/PackingGoods/editPackingInfo',
    method: 'post',
    data: data
  })
}

export function packingGoods_delPackingInfo(data) {
  return request({
    url: '/merchant/PackingGoods/delPackingInfo',
    method: 'post',
    data: data
  })
}

export function packingGoods_packingInfoDetail(data) {
  return request({
    url: '/merchant/PackingGoods/packingInfoDetail',
    method: 'get',
    params: data
  })
}
